import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type CommunicationChannel = 'whatsapp' | 'email';

export type CommunicationDto = {
  id: string;
  leadId: string;
  type: string;
  channel?: CommunicationChannel;
  direction: string;
  message: string;
  subject?: string;
  to?: string[];
  cc?: string[];
  bcc?: string[];
  status: string;
  metaMessageId?: string;
  providerMessageId?: string;
  sentBy: string;
  responseData?: Record<string, unknown>;
  createdAt?: string;
};

export type Paginated<T> = {
  items: T[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
};

@Injectable({ providedIn: 'root' })
export class CommunicationsService {
  constructor(private readonly api: ApiService) {}

  getCommunications(params: {
    leadId?: string;
    applicantId?: string;
    channel?: 'all' | CommunicationChannel;
    page?: number;
    limit?: number;
  }) {
    const query = new URLSearchParams({
      channel: params.channel ?? 'all',
      page: String(params.page ?? 1),
      limit: String(params.limit ?? 20),
    });
    if (params.applicantId?.trim()) {
      query.set('applicantId', params.applicantId.trim());
    } else if (params.leadId?.trim()) {
      query.set('leadId', params.leadId.trim());
    }
    return this.api
      .get<ApiEnvelope<Paginated<CommunicationDto>>>(`communications?${query.toString()}`)
      .pipe(map((r) => r.data));
  }
}

